import { withStyles } from '@material-ui/core/styles';
import GiftOptionsButton from './GiftOptionsButton';
import styles from './GiftOptionsButton.styles';

export default withStyles(styles)(GiftOptionsButton);
